import { CurationFeedback, CurationQueueItem } from '../interfaces/curation.interface';
import { formatDateTimePtBr } from 'src/app/menu/smart-review/core/utils/date-format.util';

export function formatCurationReviewLabel(
  item: Pick<CurationQueueItem, 'resourceType' | 'resourceId' | 'sourceDisplayName' | 'sourceName'>
): string {
  // Título humano vindo do backend (espelha o grid de reviews); cai no rótulo derivado se ausente.
  const sourceLabel = (item.sourceDisplayName || item.sourceName || '').trim();
  if (sourceLabel) {
    return sourceLabel;
  }

  const resourceType = (item.resourceType || '').toLowerCase();
  const resourceId = item.resourceId || '';

  if (resourceType === 'comparison') {
    // O resourceId pode vir com prefixo (comparison_A_B_hash) ou sem (A_B_hash).
    const match = resourceId.match(/(?:comparison_)?(\d+)_(\d+)/i);
    if (match) {
      return `#${match[1]} → #${match[2]}`;
    }
  }

  if (resourceType === 'changeset') {
    return `changeset #${resourceId}`;
  }

  if (resourceType === 'standalone') {
    return 'standalone';
  }

  return resourceId || `${item.resourceType} #`;
}

export function getCurationFeedbackUsers(item: Pick<CurationQueueItem, 'feedbacks' | 'feedbackUsers'>): string[] {
  if (item.feedbackUsers?.length) {
    return item.feedbackUsers.filter(Boolean);
  }

  return (item.feedbacks ?? []).map(feedback => feedback.user).filter(Boolean);
}

export function getCurationFeedbacks(item: Pick<CurationQueueItem, 'feedbacks'>): (CurationFeedback & { createdAtLabel: string })[] {
  return (item.feedbacks ?? []).map(f => ({
    ...f,
    createdAtLabel: formatCurationDateTime(f.feedbackedAt)
  }));
}

/**
 * Formata uma string ISO 8601 para dd/MM/yyyy HH:mm (pt-BR); `'n/d'` se ausente/inválida.
 * Delega ao formatador compartilhado em core/utils (mesma formatação da tela de review).
 */
export function formatCurationDateTime(value?: string): string {
  return formatDateTimePtBr(value);
}
